import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { setScheduleFilter } from "../../store/Actions/HomePage";
import { useTranslateText } from "../../hooks/userLanguageTranslate";
import { RootState } from "../../store";
interface Schedule {
  start: string;
  end: string;
  key: string;
  month: string;
  label: string;
  start_date_time: string;
  end_date_time: string;
  data: any[];  
  dataRoundTable: any[];
  dataPanelDiscussion: any[];
  dataOnDemand: any[];
  dataDsiplayCenter:any[];
}

interface LandingPageTabsProps {
  schedules: Schedule[];
}

const LandingPageTabs: React.FC<LandingPageTabsProps> = ({ schedules }) => {
  const dispatch = useDispatch();
  const [activeLabel, setActiveLabel] = useState<string>(schedules[0]?.label || '');
  const translateEventSchedule = useTranslateText('nav-event-schedule', 'EVENT SCHEDULE');
    const eventData = useSelector((state: RootState) => state.eventData);

  // Ensure first schedule is active
  React.useEffect(() => {
    if (schedules.length > 0 && !activeLabel) {
      setActiveLabel(schedules[0].label);
    }
  }, [schedules, activeLabel]);

  const setSchedulesFilter = useCallback(
    (e: React.MouseEvent, day_obj: Schedule) => {
      e.preventDefault();
      dispatch(setScheduleFilter(day_obj));
      setActiveLabel(day_obj.label);
    },
    [dispatch]
  );

  return (
  
        <>
        <ul className="nav nav-tabs schedule-tab" style={{
    '--active-bg': eventData.primary_color,
    '--active-border': eventData.primary_color,
    '--hover-bg': eventData.primary_color,
    '--hover-border': eventData.primary_color
  }}>
          {_.map(schedules, (day_obj) => (
            <li key={day_obj.label}>
              <a
                href={'#' + day_obj.label}
                data-toggle="tab"
                className={day_obj.label === activeLabel ? 'active show' : ''}
                onClick={(e) => setSchedulesFilter(e, day_obj)}
              >
                {day_obj.label}
              </a>
            </li>
          ))}

          {/* Extra button as per your provided HTML */}
         
        </ul>
        </>
    //   </div>
    // </div>
  );
};

export default LandingPageTabs;
